import {filter, map, startWith} from 'rxjs/operators';
import {wwData$} from '@px/streams/worker-data';
import {genShareReplyWithSubscribeHook} from '@px/helper/stream';

export const spotPTDiscountState$ = genShareReplyWithSubscribeHook<boolean>(
  wwData$.pipe(
    filter((o) => o.type === 'spot-pt-discount-state'),
    map((o) => o.data.state),
    startWith(false)
  ),
  () => {
    wwData$.next({type: 'dynamic-subscribe', method: 'subscribeSpotPtState'});
  }
);
